import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { HttpApiServiceBase } from './http-api-service-base';
import { DashboardTeamResponse } from './response/dashboard-team-response';
import { UserPropertyDashboardResponse } from './response/user-property-dashboard-response';

@Injectable({
   providedIn: 'root'
})
export class DashboardService extends HttpApiServiceBase {
   constructor(private http: HttpClient) {
      super();
   }

   getUserDashboard(
      userId: string,
      propertyId: number,
      startQueryDate: string,
      endQueryDate: string
   ): Observable<UserPropertyDashboardResponse> {
      return this.http.get<UserPropertyDashboardResponse>(
         `${environment.apiEndpoint}/dashboard/user/${encodeURIComponent(
            userId
         )}/${encodeURIComponent(propertyId)}`,
         {
            headers: this.headers,
            responseType: 'json',
            params: {
               startQueryDate,
               endQueryDate
            }
         }
      );
   }

   getTeamDashboard(propertyId: number): Observable<DashboardTeamResponse> {
      return this.http.get<DashboardTeamResponse>(
         `${environment.apiEndpoint}/dashboard/team/${encodeURIComponent(
            propertyId
         )}`,
         {
            headers: this.headers,
            responseType: 'json'
         }
      );
   }
}
